module.exports = __webpack_public_path__ + "img/cardio.4ea2387c.jpg";